import * as React from "react";
import { Context } from "./_context";
export const CaretDownIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m13.06 7.06-4.5 4.5a.75.75 0 0 1-1.06 0L3 7.06 4.06 6l3.97 3.97L12 6l1.06 1.06Z", fill: "currentColor" }));
  return iconset[size];
};
CaretDownIcon.iconId = "5b3I1p";
